import React from 'react';
import { BrandAvatar } from './Avatar';

interface Suggestion {
  icon?: React.ReactNode;
  text: string;
  onClick?: () => void;
}

interface EmptyStateProps {
  title: string;
  subtitle?: string;
  suggestions?: Suggestion[];
  icon?: React.ReactNode;
  brand?: boolean; // use the BrandAvatar G-mark
  cta?: React.ReactNode;
  maxWidth?: number;
  style?: React.CSSProperties;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  subtitle,
  suggestions,
  icon,
  brand = true,
  cta,
  maxWidth = 720,
  style,
}) => {
  return (
    <div
      style={{
        maxWidth,
        margin: '40px auto',
        padding: '0 24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        ...style,
      }}
    >
      {brand
        ? <BrandAvatar size={56} style={{ marginBottom: 18 }} />
        : icon
          ? <div style={{ marginBottom: 18, fontSize: 40, color: 'var(--fg-3)' }}>{icon}</div>
          : null}

      <div
        style={{
          fontSize: 28,
          fontWeight: 700,
          color: 'var(--fg-1)',
          letterSpacing: '-0.022em',
          fontFamily: 'var(--font-display)',
          lineHeight: 1.15,
        }}
      >
        {title}
      </div>
      {subtitle && (
        <div style={{ fontSize: 14, color: 'var(--fg-3)', marginTop: 6, marginBottom: 24, maxWidth: 480 }}>
          {subtitle}
        </div>
      )}
      {cta && <div style={{ marginTop: 8, marginBottom: 16 }}>{cta}</div>}
      {suggestions && suggestions.length > 0 && (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
            gap: 10,
            width: '100%',
            marginTop: 4,
          }}
        >
          {suggestions.map((s, i) => (
            <button
              key={i}
              type="button"
              onClick={s.onClick}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                background: 'rgba(255,255,255,0.7)',
                border: '1px solid var(--border-1)',
                borderRadius: 'var(--radius-md)',
                padding: '12px 14px',
                cursor: 'pointer',
                fontFamily: 'var(--font-sans)',
                backdropFilter: 'blur(8px)',
                WebkitBackdropFilter: 'blur(8px)',
                transition: 'all 200ms var(--ease-standard)',
                textAlign: 'left',
                color: 'var(--fg-2)',
                fontSize: 13,
              }}
            >
              {s.icon && (
                <span style={{ fontSize: 18, flexShrink: 0, lineHeight: 1 }}>{s.icon}</span>
              )}
              <span>{s.text}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default EmptyState;
